import { useReducer, createContext } from 'react';

const defaultAccordionFormState = {
  directPaymentId: '',
  farmId: '',
  name: '',
  surname: '',
  pesel: 0,
  idDocNumber: 0,
  companyName: '',
  nip: 0,
  regon: '',
  loanAmount: 0,
  loanType: '',
  loanLength: 4,
  phoneNumber: '',
  email: '',
  directPaymentYear: 0,
  directPaymentIncome: 0,
  directPaymentIdentification: 0,
  //Checkboxes
  bigAgreement: false,
  bigAgreementNIP: false,
  dataProcessingPermission: false,
  bankPermission: false,
  agrowePermission: false,
  //Additional
  additionalIncomeRequestList: [],
  animalProductionRequestList: [],
  financialLiabilityRequestList: [],
  additionalProductionResponses: [],
  animalProductionResponses: [],
  financialLiabilityResponses: [],
  //Other
  isTakingDirectPayments: '',
  hasCompany: false,
  loanApplicationID: '',
};

const defaultAccordionFormNavigationState = {
  expanded: '',
  unlocked: ['panel1'],
  finalText: '',
  loanDataLoading: false,
};

const accordionFormReducer = (state, action) => {
  if (action.field) {
    return { ...state, [action.field]: action.value };
  }
  return defaultAccordionFormState;
};

const accordionFormNavigationReducer = (state, action) => {
  if (action.type === 'CHANGE') {
    if (state.unlocked.includes(action.panel))
      return {
        ...state,
        expanded: state.expanded !== action.panel ? action.panel : false,
      };
  }
  if (action.type === 'UNLOCK') {
    return {
      expanded: action.panel,
      unlocked: [...state.unlocked, action.panel],
    };
  }
  if (action.type === 'LOADING') {
    return {
      ...state,
      loanDataLoading: action.value,
    };
  }
  if (action.type === 'TEXT') {
    return {
      ...state,
      finalText: action.value,
    };
  }
  return defaultAccordionFormNavigationState;
};

const AccordionFormContext = createContext({
  form: {},
  navigation: {},
  changeFormValue: () => {},
  changeNavigation: () => {},
  changeStatus: () => {},
});

export const AccordionFormContextProvider = (props) => {
  const [accordionFormState, dispatchFormAction] = useReducer(
    accordionFormReducer,
    defaultAccordionFormState
  );
  const [accordionNavigationState, dispatchNavigationAction] = useReducer(
    accordionFormNavigationReducer,
    defaultAccordionFormNavigationState
  );

  const changeForm = (field, value) => {
    dispatchFormAction({ field: field, value: value });
  };
  const changeNavigation = (action, panel) => {
    dispatchNavigationAction({ type: action, panel: panel });
  };
  const changeStatus = (action, value) => {
    dispatchNavigationAction({ type: action, value: value });
  };

  return (
    <AccordionFormContext.Provider
      value={{
        form: accordionFormState,
        navigation: accordionNavigationState,
        changeFormValue: changeForm,
        changeNavigation: changeNavigation,
        changeStatus: changeStatus,
      }}
    >
      {props.children}
    </AccordionFormContext.Provider>
  );
};

export default AccordionFormContext;
